// extracted by mini-css-extract-plugin
export var fadeInAnimation = "ToolIcons-module--fadeInAnimation--4e53a";
export var icon = "ToolIcons-module--icon--27fd8";
export var iconText = "ToolIcons-module--iconText--200b9";
export var tool = "ToolIcons-module--tool--b29c7";
export var withFilter = "ToolIcons-module--withFilter--16e1d";